var _path, _path2, _circle, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M196.641 85.337v341.326H0V85.337z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 196.641,
  cy: 256,
  r: 64,
  fill: "#ffda44"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z",
  fill: "#d80027"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z",
  fill: "#f0f0f0"
})));

export default SvgPt;